<template>
    <b-sidebar
    type="is-light"
    :fullheight="true"
    :fullwidth="false"
    :overlay="true"
    :right="true"
    :can-cancel="false"
    :open.sync="openSidebar"
    >
        <div class="has-text-left">
            <a
            class="has-text-danger"
            @click="sidebarToggle">
                <b-icon
                icon="times"
                size="is-small">
                </b-icon>
                Cerrar
            </a>
        </div>

        <div class="container-sidebar">
            <div class="p-1">
                <b-menu>
                    
                    <b-menu-list label="Menu">
                        <b-menu-item href="/" icon="home" label="Home"></b-menu-item>
                        <b-menu-item v-if="blogBool" :href="blogUrl" icon="newspaper" label="Blog"></b-menu-item>
                        <b-menu-item :href="contactUrl" icon="envelope" label="Contacto"></b-menu-item>
                        <b-menu-item v-if="faqsBool" :href="faqsUrl" icon="question-circle" label="Preguntas frecuentes"></b-menu-item>
                        <b-menu-item v-if="loggedUser" :href="userSettings" icon="user" label="Mi perfil"></b-menu-item>
                        <b-menu-item v-if="loggedUser" :href="logoutUrl" icon="sign-out-alt" label="Salir"></b-menu-item>
                        <b-menu-item v-if="!loggedUser" :href="registerUrl" icon="user-plus" label="Registrarme"></b-menu-item>
                        <b-menu-item v-if="!loggedUser" :href="loginUrl" icon="sign-in-alt" label="Login"></b-menu-item>
                        <b-menu-item v-for="x in navPages" v-if="x.inNav" :key="x.id" :href="x.getPublicDetail" :label="x.title"></b-menu-item>
                    </b-menu-list>
               
                    <b-menu-list v-if="isStore" label="Categorias">
                        <b-collapse
                        v-for="cat in categories"
                        v-if="cat.hideEmpty"
                        :key="cat.id"
                        animation="slide"
                        class="m-b-10"
                        :open="false">
                            <div class="level is-mobile"
                            slot="trigger"
                            slot-scope="props"
                            role="button">
                                <div class="level-left">
                                    <span class="has-text-weight-bold">{{cat.title}}</span>
                                </div>
                                <div class="level-right">
                                    <b-icon
                                        :icon="props.open ? 'times' : 'plus'"
                                        size="is-small">
                                    </b-icon>
                                </div>
                            </div>
                            <div class="">
                                <div class="content">
                                    <a class="heading has-text-weight-bold" :href="cat.getProdListUrl">Ver todos >>></a>
                                    <a class="heading p-0 m-0" v-for="sub in cat.subcategories" :key="sub.id" :href="sub.getProdListUrl">{{sub.title}}</a>
                                </div>
                            </div>
                        </b-collapse>
                        
                    </b-menu-list>
                </b-menu>
            </div>
        </div>
            
    </b-sidebar>
</template>

<script>

export default {
    
    props:{
        loggedUser:{
            type:Boolean,
            default:false
        },
        logoutUrl:{
            type:String,
            default:""
        },
        registerUrl:{
            type:String,
            default:""
        },
        loginUrl:{
            type:String,
            default:""
        },
        contactUrl:{
            type:String,
            default:""
        },
        userSettings:{
            type:String,
            default:""
        },
        searchEndpoint:{
            type:String,
            default:""
        },
        searchResultsUrl:{
            type:String,
            default:""
        },
        logo:{
            type:String,
            default:""
        },
        openSidebar:{
            type:Boolean,
            default:false
        },
        categories:{
            type:Array,
            default:new Array([])
        },
        isStore:{
            type:Boolean,
            default:false
        },
        isContent:{
            type:Boolean,
            default:false
        },
        isB2b:{
            type:Boolean,
            default:false
        },
        faqsBool:{
            type:Boolean,
            default:false
        },
        faqsUrl:{
            type:String,
            default:""
        },
        blogBool:{
            type:Boolean,
            default:false
        },
        blogUrl:{
            type:String,
            default:""
        },
        navPages:{
            type:Array,
            default: new Array([])
        }
    },
    methods:{
        sidebarToggle(){
            this.$emit("sidebarCloseEvent")
        }
    }
}
</script>
<style lang="scss" scoped>
.category-nav{
    width: 700px;
    max-height: 500px;
    overflow-y: scroll;
    margin: 0px auto;
    z-index:900;
}

a.navbar-item:hover{
    color:var(--primary) !important;
}

a.navbar-item:active{
    color:var(--primary) !important;
}

a.navbar-item:focus{
    color:var(--primary) !important;
}


a.navbar-link:hover{
    color:var(--primary) !important;
}

a.navbar-link:active{
    color:var(--primary) !important;
}

a.navbar-link:focus{
    color:var(--primary) !important;
}
.navbar-brand{
    .icon{
        color:var(--primary) ;
    }
}
.navbar-end{
    .navbar-item{
        .navbar-link:hover{
            color:var(--primary) !important;
        }
    }
}
.is-block{
    color: red;
}

.cat-card{
    margin-bottom:5px;
    border:0px #fff solid !important;
    //border-radius: 20px;
    box-shadow: 1px 2px 10px rgba(184, 184, 184, 0.45);
    .card-header{
        box-shadow: 0px 0px #fff;
        border:0px #fff solid !important;
    }
}

.container-sidebar{
    padding: 10px;
}

</style>